import React from "react";
import { Path } from "react-native-svg";

import { IconPathProps } from "../types";

const ChevronUp = ({ lineColor, strokeWidth }: IconPathProps) => (
  <Path
    d="M4.5 15L12 7.5L19.5 15"
    stroke={lineColor}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
  />
);

export default ChevronUp;
